module.exports = __webpack_public_path__ + "static/media/Squirrel-walk.3b90f6bc.gif";